import { render, staticRenderFns } from "./AppText.vue?vue&type=template&id=1d337b7e&scoped=true&"
import script from "./AppText.vue?vue&type=script&lang=js&"
export * from "./AppText.vue?vue&type=script&lang=js&"
import style0 from "./AppText.vue?vue&type=style&index=0&id=1d337b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d337b7e",
  null
  
)

export default component.exports